import React from 'react';
import Icon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';

const DeliveryInfo = ({ estimatedDelivery, shippingAddress }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
        <Icon name="Truck" size={24} className="mr-2 text-primary" />
        {t('deliveryInformation')}
      </h2>
      
      <div className="space-y-4">
        {/* Estimated Delivery */}
        <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
          <div className="flex items-center">
            <Icon name="Calendar" size={20} className="mr-3 text-primary" />
            <div>
              <p className="font-medium text-foreground">{t('estimatedDelivery')}</p>
              <p className="text-sm text-muted-foreground">{t('standardShipping')}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="font-bold text-primary">{estimatedDelivery}</p>
            <p className="text-xs text-muted-foreground">{t('businessDays')}</p>
          </div>
        </div>
        
        {/* Shipping Address */}
        <div>
          <h3 className="font-medium text-foreground mb-2 flex items-center">
            <Icon name="MapPin" size={16} className="mr-2 text-muted-foreground" />
            {t('shippingAddress')}
          </h3>
          <div className="bg-background border border-border rounded-lg p-4">
            <p className="font-medium text-foreground">{shippingAddress.name}</p>
            <p className="text-sm text-muted-foreground">{shippingAddress.street}</p>
            <p className="text-sm text-muted-foreground">
              {shippingAddress.city}, {shippingAddress.state} {shippingAddress.zipCode}
            </p>
            <p className="text-sm text-muted-foreground">{shippingAddress.country}</p>
            {shippingAddress.phone && (
              <p className="text-sm text-muted-foreground mt-2">
                <Icon name="Phone" size={14} className="inline mr-1" />
                {shippingAddress.phone}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryInfo;
